export default __webpack_public_path__ + "static/media/page.ca92cac8.png";